import { render, staticRenderFns } from "./create.view.vue?vue&type=template&id=29a40277&scoped=true"
import script from "./create.view.vue?vue&type=script&lang=js"
export * from "./create.view.vue?vue&type=script&lang=js"
import style0 from "./create.view.vue?vue&type=style&index=0&id=29a40277&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a40277",
  null
  
)

export default component.exports